import React from 'react';
import {LayoutContainer} from '../../components/LayoutContainer';
import {DrawerOrientations} from './components/DrawerOrientations';
import {HeaderGeneralOrientationsHospitalization} from './components/Header';
import {OrientationCardsGrid} from './components/OrientationCardsGrid';

export const MyHospitalizationGeneralOrientations = () => (
	<LayoutContainer>
		<HeaderGeneralOrientationsHospitalization />
		<OrientationCardsGrid />
		<DrawerOrientations />
	</LayoutContainer>
);
